<div class="col-xs-12 actions-col">
	<button class="button wide add-user-button" data-i18n="common.add"></button>
</div>
